import api from './api';

export const recurrenceService = {
  getAll: async () => {
    return api.get('/recurrences');
  },

  getById: async (recurrenceId) => {
    return api.get(`/recurrences/${recurrenceId}`);
  },

  create: async (data) => {
    return api.post('/recurrences', data);
  },

  update: async (recurrenceId, data) => {
    return api.put(`/recurrences/${recurrenceId}`, data);
  },

  delete: async (recurrenceId) => {
    return api.delete(`/recurrences/${recurrenceId}`);
  },

  pause: async (recurrenceId) => {
    return api.post(`/recurrences/${recurrenceId}/pause`);
  },

  resume: async (recurrenceId) => {
    return api.post(`/recurrences/${recurrenceId}/resume`);
  },

  process: async (date) => {
    return api.post('/recurrences/process', null, { params: { date } });
  },
};

export default recurrenceService;
